import { ProductType } from '@tink/core/src/types';
import { applicationParameters } from '../../../utilities/application-parameters';
import { AccountDialogType, ReportType } from '../../models/report';
import { BundledFlowParameters } from '../../services/reports-client';

type ReportProductTypes =
  | ProductType.REPORTS
  | ProductType.ACCOUNT_CHECK
  | ProductType.BUSINESS_ACCOUNT_CHECK;

export const isReportsProduct = (productType: ProductType): productType is ReportProductTypes => {
  return [
    ProductType.REPORTS,
    ProductType.ACCOUNT_CHECK,
    ProductType.BUSINESS_ACCOUNT_CHECK,
  ].includes(productType);
};

export const getDescribeReportsPayload = (
  productType: ReportProductTypes
): BundledFlowParameters => {
  if (productType === ProductType.REPORTS) {
    return {
      reportTypes: applicationParameters.get('reportTypes') as ReportType[],
      refreshableItems: applicationParameters.get('refreshableItems'),
      accountDialogType: applicationParameters.get('accountDialogType') as AccountDialogType,
    };
  }

  if (productType === ProductType.BUSINESS_ACCOUNT_CHECK) {
    return {
      accountDialogType: AccountDialogType.SINGLE,
      reportTypes: [ReportType.BUSINESS_ACCOUNT_VERIFICATION_REPORT],
      refreshableItems: applicationParameters.get('refreshableItems'),
    };
  }

  if (productType === ProductType.ACCOUNT_CHECK) {
    return {
      accountDialogType: AccountDialogType.SINGLE,
      reportTypes: [ReportType.ACCOUNT_VERIFICATION_REPORT],
      refreshableItems: applicationParameters.get('refreshableItems'),
    };
  }

  throw new Error('This is not implemented for other products');
};
